<div class="personal-data-container component-container">
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
    <app-section-header
      [title]="'personal-data.form-details.invoice-address-title' | translate"
      [tooltip]="'tooltips.personal-data.invoice-address' | translate"></app-section-header>
  </div>

  <form [formGroup]="invoiceAddressDataFG" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-section form-font-size">
    <div class="ui-g form-rows">
      <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
        <label class="ui-g-5 field-label text-right-align required" for="invoice-data-title">
          {{ 'personal-data.form-details.fields.title' | translate }}
        </label>
        <p-dropdown [options]="allTitles" formControlName="title" id="invoice-data-title" placeholder="-Select-" [readonly]="isReadOnly">
          <ng-template let-item pTemplate="selectedItem">
            <span class="drop-item-label">{{ 'lookup.' + titleKey + '.options.' + item['value'] + '.name' | translate }}</span>
          </ng-template>
          <ng-template let-option pTemplate="item">
            <div class="drop-item">
              <span class="drop-item-label">{{ 'lookup.' + titleKey + '.options.' + option['value'] + '.name' | translate }}</span>
            </div>
          </ng-template>
        </p-dropdown>
      </div>
      <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
        <label class="ui-g-5 field-label text-right-align" for="personal-data-company">
          {{ 'personal-data.form-details.fields.company' | translate }}
        </label>
        <input
          class="ui-input pInputText"
          formControlName="company"
          id="personal-data-company"
          pInputText
          size="30"
          maxlength="50"
          type="text"
          [readonly]="isReadOnly" />
      </div>
    </div>

    <div class="ui-g form-rows">
      <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
        <label class="ui-g-5 field-label text-right-align required" for="invoice-data-fname">
          {{ 'personal-data.form-details.fields.first-name' | translate }}
        </label>
        <input
          class="ui-input pInputText"
          formControlName="firstName"
          id="invoice-data-fname"
          pInputText
          size="30"
          maxlength="50"
          type="text"
          [readonly]="isReadOnly" />
      </div>

      <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding">
        <label class="ui-g-5 field-label text-right-align required" for="invoice-data-lname">
          {{ 'personal-data.form-details.fields.last-name' | translate }}
        </label>
        <input
          class="ui-input pInputText"
          formControlName="lastName"
          id="invoice-data-lname"
          pInputText
          size="30"
          maxlength="50"
          type="text"
          [readonly]="isReadOnly" />
      </div>
    </div>

    <div class="ui-g form-rows">
      <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
        <label class="ui-g-5 field-label text-right-align required" for="invoice-data-street">
          {{ 'personal-data.form-details.fields.street' | translate }}
        </label>
        <input
          class="ui-input pInputText"
          formControlName="street"
          id="invoice-data-street"
          pInputText
          size="30"
          maxlength="30"
          type="text"
          [readonly]="isReadOnly" />
      </div>

      <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding">
        <label class="ui-g-5 field-label text-right-align required" for="invoice-data-street-no">
          {{ 'personal-data.form-details.fields.street-number' | translate }}
        </label>
        <input
          class="ui-input pInputText"
          formControlName="streetNo"
          id="invoice-data-street-no"
          pInputText
          size="30"
          maxlength="5"
          type="text"
          [readonly]="isReadOnly" />
      </div>
    </div>

    <div class="ui-g form-rows">
      <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
        <label class="ui-g-5 field-label text-right-align" for="invoice-data-address-suffix">
          {{ 'personal-data.form-details.fields.address-suffix' | translate }}
        </label>
        <input
          class="ui-input pInputText"
          formControlName="addressSuffix"
          id="invoice-data-address-suffix"
          pInputText
          size="30"
          type="text"
          [readonly]="isReadOnly" />
      </div>

      <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding">
        <label class="ui-g-5 field-label text-right-align required" for="invoice-data-land">
          {{ 'personal-data.form-details.fields.land' | translate }}
        </label>
        <input
          class="ui-input pInputText"
          formControlName="land"
          id="invoice-data-land"
          pInputText
          size="30"
          type="text"
          [readonly]="isReadOnly" />
      </div>
    </div>

    <div class="ui-g form-rows">
      <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
        <label class="ui-g-5 field-label text-right-align required" for="invoice-data-city">
          {{ 'personal-data.form-details.fields.city' | translate }}
        </label>
        <input
          class="ui-input pInputText"
          formControlName="city"
          id="invoice-data-city"
          pInputText
          size="30"
          maxlength="100"
          type="text"
          [readonly]="isReadOnly" />
      </div>

      <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding">
        <label class="ui-g-5 field-label text-right-align required" for="invoice-data-postcode">
          {{ 'personal-data.form-details.fields.post-code' | translate }}
        </label>
        <input
          class="ui-input pInputText"
          formControlName="postCode"
          id="invoice-data-postcode"
          pInputText
          size="30"
          [appNumber]="true"
          [readonly]="isReadOnly" />
      </div>
    </div>

    <div class="ui-g form-rows">
      <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
        <label class="ui-g-5 field-label text-right-align required" for="invoice-data-telephone">
          {{ 'personal-data.form-details.fields.telephone' | translate }}
        </label>
        <input
          class="ui-input pInputText"
          formControlName="telephone"
          id="invoice-data-telephone"
          pInputText
          size="30"
          maxlength="50"
          [appNumber]="true"
          [readonly]="isReadOnly" />
      </div>

      <div *ngIf="invoiceAddressDataFG.get('mobile')" class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding">
        <label class="ui-g-5 field-label text-right-align" for="invoice-data-mobile">
          {{ 'personal-data.form-details.fields.mobile' | translate }}
        </label>
        <input
          class="ui-input pInputText"
          formControlName="mobile"
          id="invoice-data-mobile"
          pInputText
          size="30"
          maxlength="50"
          [appNumber]="true"
          [readonly]="isReadOnly" />
      </div>
    </div>
    <div class="ui-g form-rows">
      <div *ngIf="invoiceAddressDataFG.get('email')" class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding">
        <label class="ui-g-5 field-label text-right-align" [class.required]="environmentService.showEmailRequired" for="invoice-data-email">
          {{ 'personal-data.form-details.fields.email' | translate }}
        </label>
        <input
          class="ui-input pInputText"
          formControlName="email"
          id="invoice-data-email"
          pInputText
          size="30"
          maxlength="50"
          type="text"
          [readonly]="isReadOnly" />
      </div>
    </div>

    <div class="ui-g form-rows">
      <div *ngIf="invoiceAddressDataFG.get('repeatEmail')" class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding">
        <label
          class="ui-g-5 field-label text-right-align"
          [class.required]="environmentService.showEmailRequired"
          for="invoice-data-repeat-email">
          {{ 'personal-data.form-details.fields.repeat-email' | translate }}
        </label>
        <input
          class="ui-input pInputText"
          formControlName="repeatEmail"
          id="invoice-data-repeat-email"
          pInputText
          size="30"
          maxlength="50"
          type="text"
          [readonly]="isReadOnly" />
      </div>
    </div>
  </form>
</div>
